
import { useEffect, Fragment } from 'react';
import useAuthentication from '@zorgconnect/shared-portal/Modules/Authentication/Service/hooks/useAuthentication';
import authenticationService from '@zorgconnect/shared-portal/Modules/Authentication/Service';
import { useSelector } from 'react-redux';
import { Map, List } from 'immutable';



export const PortalMenu = () => {
    
    const { userInfo } = useAuthentication();

    const user = useSelector(state => state.getIn(['users','single'], Map()));

    useEffect(() => {
        authenticationService.getUserInfo();
    }, []);


    if(!user || !userInfo) {
        return null;
    }

    const clientPortals = (user.getIn(['clientportal'], List()) || List()).filter((clientPortal) => userHasPortalActive({ userInfo, clientPortal }));

    console.log("clientPortals", clientPortals.toJS());


    const onOpenPortal = async (clientPortal) => {
        let aclRequest = {};
        if(clientPortal.get('usertype') === 'client') {
            aclRequest.clientid = clientPortal.get('clientid');
        } else if(clientPortal.get('usertype') === 'contact') {
            aclRequest.contactid = clientPortal.get('contactid');
        } else if(clientPortal.get('usertype') === 'freelancer') {
            aclRequest.freelancerid = clientPortal.get('freelancerid');
        }
        await authenticationService.renewToken(aclRequest);
        window.location.href = '/';
    }


    return <Fragment>
        <h2 className="menu-header">Portalen</h2>
        <ul className="inner-menu">


            {clientPortals.map((clientPortal) => (
                <li key={clientPortal.get('id')} style={{ cursor: 'pointer' }} onClick={() => onOpenPortal(clientPortal)}>
                    Clientportaal: {clientPortal.get('clientid')}
                </li>
            ))}
        </ul>
    </Fragment>;
};


function userHasPortalActive({ userInfo, clientPortal }) {

    let services = userInfo.getIn(['services'], List()) || List();

    let portalType = clientPortal.get('usertype');

    if(portalType === 'client') {
        return services.some((service) => service.get('clientId') == clientPortal.get('clientid'));
    } else if(portalType === 'contact') {
        return services.some((service) => service.get('contactId') == clientPortal.get('contactid'));
    }

    return false;
}